import React from "react";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { selectBaseUrl } from "../redux/slices/p2pSettingsSlice";
import { selectAllFormSettings } from "../redux/slices/formSettingsSlice";
import Routes from "./Routes";

const ConnectedRoutes = () => {
    const baseUrl = useSelector(selectBaseUrl);
    const formSettings = useSelector(selectAllFormSettings);
    const { id = 0, org = 0, title = "", type = 0 } = formSettings;
    const routesProps = {
        formId: id,
        formType: type,
        orgId: org,
        title,
        baseUrl,
    };
    return <Routes {...routesProps} />;
};

export default ConnectedRoutes;
